import { motion } from "framer-motion";
import { useAuth } from "../../context/AuthContext";

const UserMetadata = ({ userData }) => {
  const { user } = useAuth();

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  const calculateStorageUsage = () => {
    if (!userData) return "0 MB";

    let totalSize = 0;

    // Calculate files size
    Object.values(userData.files).forEach((fileType) => {
      fileType.forEach((file) => {
        totalSize += file.size || 0;
      });
    });

    // Convert to MB
    return `${(totalSize / (1024 * 1024)).toFixed(2)} MB`;
  };

  return (
    <motion.div
      className="user-metadata"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.2 }}
    >
      <h2>Account Information</h2>

      <div className="info-card">
        <h3>Basic Information</h3>
        <div className="info-row">
          <span className="info-label">Username:</span>
          <span className="info-value">{user?.username}</span>
        </div>
        <div className="info-row">
          <span className="info-label">Email:</span>
          <span className="info-value">{user?.email}</span>
        </div>
        <div className="info-row">
          <span className="info-label">Account Status:</span>
          <span className="info-value">Active</span>
        </div>
      </div>

      <div className="info-card">
        <h3>Account Activity</h3>
        <div className="info-row">
          <span className="info-label">Member Since:</span>
          <span className="info-value">
            {formatDate(userData?.metadata?.joinedDate)}
          </span>
        </div>
        <div className="info-row">
          <span className="info-label">Last Login:</span>
          <span className="info-value">
            {formatDate(userData?.metadata?.lastLogin)}
          </span>
        </div>
        <div className="info-row">
          <span className="info-label">Active Sessions:</span>
          <span className="info-value">1 (Current Device)</span>
        </div>
      </div>

      <div className="info-card">
        <h3>Storage Information</h3>
        <div className="info-row">
          <span className="info-label">Total Storage Used:</span>
          <span className="info-value">{calculateStorageUsage()}</span>
        </div>
        <div className="info-row">
          <span className="info-label">Images Stored:</span>
          <span className="info-value">
            {userData?.files?.images.length || 0}
          </span>
        </div>
        <div className="info-row">
          <span className="info-label">Videos Stored:</span>
          <span className="info-value">
            {userData?.files?.videos.length || 0}
          </span>
        </div>
        <div className="info-row">
          <span className="info-label">Documents Stored:</span>
          <span className="info-value">
            {userData?.files?.documents.length || 0}
          </span>
        </div>
      </div>

      <div className="info-card">
        <h3>Security Information</h3>
        <div className="info-row">
          <span className="info-label">Passwords Saved:</span>
          <span className="info-value">{userData?.passwords?.length || 0}</span>
        </div>
        <div className="info-row">
          <span className="info-label">Notes Created:</span>
          <span className="info-value">{userData?.notes?.length || 0}</span>
        </div>
        <div className="info-row">
          <span className="info-label">Last Password Change:</span>
          <span className="info-value">Never</span>
        </div>
      </div>
    </motion.div>
  );
};

export default UserMetadata;
